module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwAQMAAABtzGvEAAAABlBMVEUAAADMzMzIT8AyAAAAAXRSTlMAQObYZgAAABNJREFUGNNjGPyA8f//Bhg16AEARrAE/47MvVkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/shop_reduce_gray.png
// module id = 80
// module chunks = 40